/*
* blazingcard
* http://www.blazingcard.com
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutSandbox } from '../../../../../core/admin/layout/layout.sandbox';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { PermissionServices } from '../../shared/components/services/permission.services';
import { SettingsService } from '../../../../../core/admin/settings/settings.services';
declare var $: any;

@Component({
  selector: 'app-common-layout',
  templateUrl: './common.component.html',
  styleUrls: ['./common.component.scss']
})

export class CommonLayoutComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};
  public userDetails: any;
  private subscriptions: Array<Subscription> = [];
  public isCollapsed = false;
  public innerWidth: any;
  public defaultSidebar: any;
  public showMobileMenu = false;
  options = {
    theme: 'light', // two possible values: light, dark
    dir: 'ltr', // two possible values: ltr, rtl
    layout: 'horizontal', // fixed value. shouldn't be changed.
    sidebartype: 'full', // fixed value. shouldn't be changed.
    sidebarpos: 'absolute', // two possible values: fixed, absolute
    headerpos: 'fixed', // two possible values: fixed, absolute
    boxed: 'full', // two possible values: full, boxed
    navbarbg: 'skin1', // six possible values: skin(1/2/3/4/5/6)
    sidebarbg: 'skin6', // six possible values: skin(1/2/3/4/5/6)
    logobg: 'skin1' // six possible values: skin(1/2/3/4/5/6)
  };
  public imageUrl: any;
  showReportSubMenu: boolean = false;
  showCmsSubMenu: boolean = false;
  showSalesSubMenu: boolean = false;
  showCatalogSM: boolean = false;
  showCustomerSM: boolean = false;
  showVendorSM: boolean = false;
  checked: boolean;
  checked1: boolean;
  settinfgData : any;
  logoImage : any;

  constructor(
    public router: Router, 
    public layoutSandbox: LayoutSandbox, 
    public permissionServices: PermissionServices,
    public service : SettingsService
  ) {}

  ngOnInit() {
    this.imageUrl = environment.imageUrl;
    if (this.router.url === '/') {
      this.router.navigate(['/starter']);
    }
    const userdetail = localStorage.getItem('adminUserdetail') ? JSON.parse(localStorage.getItem('adminUserdetail')) : {};
    this.defaultSidebar = this.options.sidebartype;
    this.handleSidebar();
    this.registerEvents();
    this.userDetails = userdetail.userdetails;
    this.getSettings();
    this.permissionServices.initializePermissions();
    setTimeout(() => {
      this.permissionServices.initializePermissionConfig();
    }, 1000);  
    this.getData();  
  }

  handleSidebar() {
    this.innerWidth = window.innerWidth;
    switch (this.defaultSidebar) {
      case 'full':
        if (this.innerWidth < 1170) {
          this.options.sidebartype = 'mini-sidebar';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;
      default:
    }
  }

  private registerEvents() {
    this.subscriptions.push(
      this.layoutSandbox.user$.subscribe(user => {
        if (user) {
          this.userDetails = user.userdetails;
        }
      })
    );
  }

  getSettings() {
    this.layoutSandbox.getSettings();
  }

  /**
   * @method -- get setting details
   */
  getData() {
    this.service.getSettings().subscribe((result : any) => {
      if(result && result.data) {
        this.settinfgData = result.data[0];
        if(this.settinfgData.cloudImageUrl && this.settinfgData.cloudImageFolder && this.settinfgData.storeLogoPath && this.settinfgData.storeLogo) {
          this.logoImage = this.settinfgData.cloudImageUrl + '' + this.settinfgData.cloudImageFolder + "/" + this.settinfgData.storeLogoPath  + "/"+  this.settinfgData.storeLogo;
        }
      }
    })
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.handleSidebar();
  }

  @HostListener('document:click', ['$event']) 
  onDocumentClick(event) {
    this.checked = false;
    this.checked1 = false;
    this.showVendorSM = false;
    this.showCustomerSM = false;
    this.showCatalogSM = false;
    this.showCmsSubMenu = false;
    this.showSalesSubMenu = false;
    this.showReportSubMenu = false;
  }

  selectSubmenu() {
  }
  onClick(e) {
    this.checked = true;
    this.checked1 = false;
  }
  onClick1(e) {
    this.checked1 = true;
    this.checked = false;
  }
}